import React from "react";

interface TableProps {
  children: JSX.Element | JSX.Element[] | null;
}

const Table = (props: TableProps) => {
  const { children } = props;
  return <div style={styles.container}>{children}</div>;
};

const styles = {
  container: {
    flex: 1,
  },
};

export default Table;
